import { css } from "@emotion/react";

export const menuExpansionNodeStyles = {
  dividerMargins: css({
    marginLeft: "1rem",
    marginRight: "1rem",
  }),
};
